export default "__VITE_ASSET__BuSvuRJK__"